(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    document.querySelectorAll('.vp').forEach(function(box){
      var btn=box.querySelector('.vp__btn'),v=box.querySelector('video');
      if(!btn||!v||box.dataset.vpInit)return;box.dataset.vpInit=1;
      btn.addEventListener('click',function(){
        document.querySelectorAll('.vp video').forEach(function(o){if(o!==v)o.pause();});
        if(!v.src&&v.dataset.src)v.src=v.dataset.src;
        box.classList.add('is-playing');v.controls=true;
        var p=v.play();
        if(p&&p.catch)p.catch(function(){v.controls=true;});
        v.focus&&v.focus({preventScroll:true});
      });
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();
